<template>
    <div class="w-full h-40px flex items-center px-[15px] cursor-pointer" @click="dialogVisible = true">导入JSON</div>
    <el-dialog v-model="dialogVisible" title="导入JSON" width="520">
        <!-- <div class="format-row">
            <el-radio-group v-model="format">
                <el-radio label="yft">YFT格式</el-radio>
                <el-radio label="ck">创客贴格式</el-radio>
            </el-radio-group>
        </div> -->
        <el-input v-model="jsonText" type="textarea" placeholder="请输入JSON数据" :rows="8" />
        <div class="footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" style="background-color:#2a66ff;" @click="onConfirm">确认导入</el-button>
        </div>
    </el-dialog>
</template>
<script lang="ts" setup>
import { ref, watch } from 'vue'
import { ElDialog, ElMessage, ElInput, ElButton, ElRadio, ElRadioGroup } from 'element-plus'
import { resourcerFileUpload } from '@/api/design/resource'
import { useSdkStore } from '@/stores/sdk'

const sdkStore = useSdkStore()
const desginsdk = sdkStore.getSdk()

const dialogVisible = ref(false)
const format = ref<'yft' | 'ck'>('yft')
const jsonText = ref('')

const onConfirm = async () => {
    const txt = jsonText.value.trim()
    if (!txt) { ElMessage.warning('请输入JSON数据'); return }
    try {
        JSON.parse(txt)
    } catch {
        ElMessage.error('JSON格式不正确')
        return
    }
    try {
        if (format.value === 'yft') {
            await desginsdk.designOpt.requireJson(txt)
        } else {
            await desginsdk.designOpt.requireCKJSON(txt)
        }
        dialogVisible.value = false
    } catch (error) {
        console.error(error)
        ElMessage.error('导入失败')
    }
}
watch(dialogVisible, (newVal) => {
    if (!newVal) {
        jsonText.value = ''
    }
})
</script>
<style lang="scss" scoped>
.format-row {
    margin-bottom: 12px;
}

.footer {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}
</style>
